import { render, staticRenderFns } from "./ShippingLabelPrinter.vue?vue&type=template&id=7dfa37ba&"
import script from "./ShippingLabelPrinter.vue?vue&type=script&lang=js&"
export * from "./ShippingLabelPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports